import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import { SubmittalsItemDisplay } from './common';
import BlockRemoveButton from '../../../BlockRemoveButton';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import UnstyledAnchor from '../../../UnstyledAnchor';
import { SubmittalsItem } from '../types';
import { generateSubmittalItemLink } from '../utils/navigator';

const EntityBlock: ReferencePickerPlugin<SubmittalsItem>['EntityBlock'] = ({
  entity,
  projectId,
  onRemoveClick,
  onClick,
}) => (
  <UnstyledAnchor
    style={[
      {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        padding: '12px 16px',
        cursor: 'pointer',
        borderBottom: `1px solid ${theme.colors.charcoal100}`,
        '.submittalsEntityBlock__remove-button': {
          visibility: 'hidden',
        },
        '&:hover .submittalsEntityBlock__remove-button': {
          visibility: 'visible',
        },
      },
    ]}
    onClick={onClick}
    href={generateSubmittalItemLink(projectId, entity.id)}
  >
    <SubmittalsItemDisplay item={entity} />

    {onRemoveClick && (
      <Flex alignItems="center">
        <BlockRemoveButton
          className="submittalsEntityBlock__remove-button"
          onClick={onRemoveClick}
        />
      </Flex>
    )}
  </UnstyledAnchor>
);

EntityBlock.displayName = 'SubmittalsEntityBlock';

export default EntityBlock;
